import { createSvgIcon } from '@mui/material';

const IconFilterListFilled = createSvgIcon(
  <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" />,
  'filter_list_filled'
);

export default IconFilterListFilled;
